<template>
  <div class="account">
    <div class="framemidmem">
      <div style="width: 810px; margin: 0 auto">
        <div style="width: 240px; height: 430px; background-color: #f0f0f0; border: solid 1px #e1e1e1; float: left">
          <div style="padding: 5px 0px 10px 10px">ID Game: 
            <span id="ctl00_lblPlayID" style="font-weight:bold;">
              {{ user.account }}
            </span>
          </div>          

          <Menu />

        </div>
        <div style="width: 556px; height: auto; min-height: 430px; background-color: #f0f0f0; border: solid 1px #e1e1e1; float: left; margin-left: 10px;">
          <div style="width: 100%">
            <div style="float: left; padding: 5px 5px 10px 10px"><img id="ctl00_MemIcon"
                src="templates/images/ico-tkgame.png" style="border-width:0px;"></div>
            <div style="float:left; padding-top: 5px">
              <div style="padding-bottom: 4px"><span id="ctl00_lblTitle" class="smalltitle">Nhập Code nhận quà</span></div>
              <div
                style="background-image: url('templates/images/gachngang-trangtrong-dai.gif'); width: 514px; height: 1px">
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
          <div style="padding: 20px;">
            <div class="col-md-8">                
                <div class="">
                  <div class="text-left"><label for="account">Tài khoản</label> &nbsp;&nbsp;&nbsp; <b class="text-red">{{ user.account }}</b></div>
                  <div>
                    <div class="text-left"><label for="email">Giftcode</label></div>
                    <div><input type="giftcode" maxlength="55" v-model="giftcode" placeholder="Nhập Giftcode để nhận quà"
                        class="form-control" id="giftcode"></div>
                  </div>
                  <br>
                  <button class="btn btn-warning btn-sm" v-on:click="giftCode()">Nhận quà</button>
                </div>
              </div>
          </div>
        </div>
        <div style="clear: both">

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  import Vue from 'vue'
  import Menu from './Menu'

  export default {
    name: 'Giftcode',
    components: {
      Menu
    },
    props: {
      tqc_api: '',
      token: '',
      user: {}
    },
    mounted() {
      this.$emit('get-info')
    },
    methods: {
      giftCode() {
        if (this.clicked) {
          return false
        }
        if (!this.validate()) {
          return false
        }

        this.clicked = true

        axios.post(`${this.tqc_api}gift-code`, {
            token: this.token,
            giftcode: this.giftcode,
          }).then(({
            data
          }) => {
            if (data.error) {
              alert(data.error)
            } else {
              alert(data.data)
            }
            this.clicked = false
          }).catch(error => {
            this.clicked = false
            alert('Thông tin không chính xác !')
          })
      },
      validate() {
        if (this.giftcode.length < 6) {
          alert('Giftcode không được để trống !')
          return false
        }

        return true
      }
    },
    data() {
      return {
        giftcode: '',
        clicked: false
      }
    }
  }
</script>

<style scoped>
  h3 {
    margin: 40px 0 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }

  #reset_content {
    font-size: 16px;
  }

  .text-red {
    color: red;
  }

  .text-green {
    color: #2be428;
  }

  input {
    height: 35px;
    margin-bottom: 8px;
  }

  .frm_gift_code {
    width: 50%;
    margin: auto;
  }
</style>